import { CircularProgress, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useEffect, useState } from 'react';
import SvgDelete from '../Icons/SvgDelete';
import ReportCreateNewLabelField from '../ReportCreateNewLabelField';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import ToggleGroup from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/ToggleGroup';
import { ICohortDetails } from '../../organisms/CreateNewModalCoreComponent';
import AutocompleteWithCheckBoxes from '../Autocomplete';
import properties from '../../../core-utils/properties';
import axios from 'axios';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { TextField } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { roundNumber } from '../../../core-utils/helper-utils/helper';
import { Autocomplete } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useStores } from '../../../stores';
import { observer } from 'mobx-react';
import SvgRefresh from '../Icons/Refresh';
import { toJS } from 'mobx';
import { CircularLoader } from '@HomaHealth/ui-component-library';

export interface ReportsCohortItemProps {
  handleDeleteCohort: (index: number, refresh?: boolean) => any;
  propertyDropDownOptions: string[][];
  categoryDropDownOptions: string[];
  // subCategoryDropDownOptions?: string[][];
  conditionDropDownOptions: string[][];
  setPropertyDropDownOptions: React.Dispatch<React.SetStateAction<string[][]>>;
  cohortSelectionsValues: string[];
  totalResults: string;
  startDate?: string;
  endDate?: string;
  employerGroup?: string[];
  type?: string;
}

interface ToggleValue {
  toggleValue?: 'and' | 'or';
}

//common dropdown props
export const commonDropDownProps = {
  selectStyles: {
    height: '36px',
    '& >.MuiOutlinedInput-input': {
      padding: '6px 16px',
      fontSize: '14px',
      lineHeight: '24px',
      color: patientAccessTheme.palette.text.highemphasis,
    },
  },
  labelTop: '10px',
};

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
  },
  cohortItem: {
    display: 'flex',
    alignItems: 'center',
  },
  inputFieldsGrid: {
    width: '656px',
    marginRight: '100px',
    background: '#FBFBFE',
    padding: '16px 20px',
    borderRadius: '8px',
  },
  resultsGrid: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 26px',
    width: '240px',
    borderRadius: '8px',
    backgroundColor: '#E9EFFF',
  },
  lineAndResultsGrid: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    height: '154px',
  },
  autoCompleteDropdown: {
    '&  > .MuiInputBase-root': {
      height: '36px',
      width: '301px',
      border: 'none',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: '4px 0px 4px 8px',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '0px',
      paddingLeft: '4px',
    },
    '&. MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"] .MuiAutocomplete-input': {
      padding: '0px',
      paddingLeft: '4px',
    },
  },
  autoCompleteInput: {
    border: 'none',
    backgroundColor: patientAccessTheme.palette.status.white,
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    },
    '& input': {
      fontSize: '14px',
      lineHeight: '24px',
      color: patientAccessTheme.palette.text.mediumemphasis,
      fontWeight: 500,
    },
    '& input::placeholder': {
      fontSize: '14px',
      lineHeight: '24px',
      color: patientAccessTheme.palette.text.mediumemphasis,
      fontWeight: 500,
    },
    '& .MuiAutocomplete-input': {
      padding: '0px',
      height: '27px',
    },
    '&. MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"] .MuiAutocomplete-input': {
      padding: '0px',
    },
  },
  paper: {
    boxShadow: 'none',
    margin: '0px',
  },
  tag: {
    margin: '3px 8px',
  },
});

const ReportsCohortItem: React.FC<ReportsCohortItemProps> = observer(
  ({
    handleDeleteCohort,
    categoryDropDownOptions,
    // subCategoryDropDownOptions,
    conditionDropDownOptions,
    propertyDropDownOptions,
    cohortSelectionsValues,
    setPropertyDropDownOptions,
    totalResults,
    startDate,
    endDate,
    employerGroup,
    type,
  }) => {
    const { classes } = useStyles();
    const constants = componentConstants.ATOMS.COHORT_DETAILS;
    const toggleStyles = {
      color: patientAccessTheme.palette.status.white,
      background: patientAccessTheme.palette.primary[500],
      fontWeight: 600,
      fontSize: '12px',
      paddingRight: '14px',
    };

    const [selectedToggle, setSelectedToggle] = useState<'left' | 'right'>(
      'left',
    );

    // const [loadingProperties, setLoadingProperties] = useState(false);
    const [loadingPropertiesByIndex, setLoadingPropertiesByIndex] = useState<
      Record<number, boolean>
    >({});

    const [loadingCohort, setLoadingCohort] = useState(false);

    const [propertiesSearchValue, setPropertiesSearchValue] = useState<string>(
      '',
    );

    const [toggleList, setToggleList] = useState<ToggleValue[]>([]);

    const summaryCardsStore = useStores().summaryCardsStore;
    const cohortDetailsStore = useStores().cohortDetailsStore;
    const cohortDetailsList = toJS(cohortDetailsStore.cohortDetailsList);

    const addToggleObject = () => {
      const toggleListLength = toggleList.length;
      if (toggleListLength < cohortDetailsList.length - 1) {
        setToggleList((prev: any) => {
          const updatedToggleList = [...prev, { toggleValue: 'and' }];
          summaryCardsStore.addToggleConditions(updatedToggleList);
          return updatedToggleList;
        });
      }
    };

    const handleToggleList = (index: number) => {
      if (cohortDetailsList?.length >= 2) {
        let updatedToggleList = [...toggleList];

        if (index === 0) {
          updatedToggleList = updatedToggleList.slice(1);
        } else {
          updatedToggleList = updatedToggleList.filter(
            (_, i) => i !== index - 1,
          );
        }

        setToggleList(updatedToggleList);
        summaryCardsStore.addToggleConditions(updatedToggleList);
      }

      getTotalMembers(cohortDetailsList);
    };

    const handleToggleChange = (index: any, toggleValue?: 'left' | 'right') => {
      if (index < toggleList.length) {
        if (toggleValue === 'left') {
          toggleList[index].toggleValue = 'and';
        } else {
          toggleList[index].toggleValue = 'or';
        }
      }
      summaryCardsStore.addToggleConditions([...toggleList]);
      setToggleList([...toggleList]);

      getTotalMembers(cohortDetailsList);
    };

    //Events for PropertyDropdown
    const handlePageNumber = (
      index: number,
      pageNumber: number,
      pageType: string,
    ) => {
      const updatedCohorts = cohortDetailsList?.map(
        (cohortDetails, cohortIndex) => {
          const updatedCohort: ICohortDetails = cohortDetails;
          if (cohortIndex === index) {
            if (pageType === 'propertiesPageNumber') {
              updatedCohort.propertiesPageNumber = pageNumber;
            } else if (pageType === 'totalPagesForProperties') {
              updatedCohort.totalPagesForProperties = pageNumber;
            }
          }
          return updatedCohort;
        },
      );
      cohortDetailsStore.setCohortDetailsList(updatedCohorts);
    };

    const handleScrollEvent = async (
      category: string,
      index: number,
      dropdownSelectionTypeIndex: number,
      propertiesPageNumber: number,
      totalPagesForProperties: number,
    ) => {
      if (propertiesPageNumber + 1 < totalPagesForProperties) {
        handlePageNumber(
          index,
          propertiesPageNumber + 1,
          'propertiesPageNumber',
        );
        getPropertyValues(
          category,
          propertiesSearchValue,
          propertiesPageNumber + 1,
          false,
          index,
          dropdownSelectionTypeIndex,
        );
      }
    };

    const handleTextFieldForProperties = (
      event: any,
      category: string,
      index: number,
      dropdownSelectionTypeIndex: number,
    ) => {
      handlePageNumber(index, 0, 'propertiesPageNumber');
      setPropertiesSearchValue(event?.target?.value);
      getPropertyValues(
        category,
        event?.target?.value,
        0,
        true,
        index,
        dropdownSelectionTypeIndex,
      );
    };

    const getPropertyValues = async (
      category: string | unknown,
      searchValue: string,
      pageNumber: any,
      isSearch: boolean,
      cohortDetailsIndex: number,
      dropdownSelectionTypeIndex: number,
    ) => {
      // setLoadingProperties(true);
      setLoadingPropertiesByIndex((prev) => ({
        ...prev,
        [cohortDetailsIndex]: true,
      }));

      await axios
        .get(
          properties.aiqBaseUrl +
            properties.summaryBaseUrl +
            properties.drillDown +
            properties.drillDownSearch,
          {
            params: {
              category: category,
              searchValue: searchValue,
              pageNumber: pageNumber,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const updatedPropertyDropDown: string[][] = propertyDropDownOptions?.map(
              (propertyDropdown, dropDownindex) => {
                let updatedDropDownOptions: any = propertyDropdown;
                if (dropDownindex === dropdownSelectionTypeIndex) {
                  if (isSearch || pageNumber === 0) {
                    updatedDropDownOptions = [...res?.data?.data[0].data];
                  } else {
                    updatedDropDownOptions = [
                      ...propertyDropdown,
                      ...res?.data?.data[0]?.data,
                    ];
                  }
                }
                return updatedDropDownOptions;
              },
            );
            setPropertyDropDownOptions([...updatedPropertyDropDown]);
            const totalSize = res?.data?.data[0]?.totalSize;
            handlePageNumber(
              cohortDetailsIndex,
              Math.ceil(totalSize / 10),
              'totalPagesForProperties',
            );
          }
        })
        .catch((error) => error);
      // setLoadingProperties(false);
      setLoadingPropertiesByIndex((prev) => ({
        ...prev,
        [cohortDetailsIndex]: false,
      }));
    };

    const getTotalMembers = async (
      updatedCohortDetails: ICohortDetails[],
    ): Promise<number | null> => {
      let searchParams = '';

      updatedCohortDetails?.forEach((updatedcohort, index) => {
        const hasProperty =
          updatedcohort?.property !== null && updatedcohort?.property !== '';
        const hasMultipleProperties =
          Array.isArray(updatedcohort?.multipleProperties) &&
          updatedcohort.multipleProperties.length > 0;

        if (
          !updatedcohort?.category ||
          !updatedcohort?.condition ||
          (!hasProperty && !hasMultipleProperties)
        ) {
          return;
        }

        if (hasProperty) {
          searchParams +=
            updatedcohort.category +
            '~' +
            updatedcohort.condition +
            '~' +
            updatedcohort.property +
            '^';
        } else {
          const joined = (updatedcohort.multipleProperties ?? []).join(';');
          searchParams +=
            updatedcohort.category +
            '~' +
            updatedcohort.condition +
            '~' +
            joined +
            '^';
        }

        if (toggleList.length > 0 && index < toggleList.length) {
          searchParams += toggleList.at(index)?.toggleValue + '^';
        }
      });

      searchParams = searchParams.replace(/\^+$/, '');

      setLoadingCohort(true);
      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.summaryBaseUrl +
            properties.searchCohortMembers,
          {
            startDate,
            endDate,
            eg_nid: employerGroup,
            searchParams,
            type: type ?? 'data',
          },
        );
        const data = response?.data?.data;
        cohortDetailsStore.addMemberUniqueIdList(data?.member_ids);
        cohortDetailsStore.addClaimIdList(data?.claim_ids);
        return data?.member_ids_count ?? 0;
      } catch (error) {
        console.error('Failed to fetch cohort members:', error);
        return null;
      } finally {
        setLoadingCohort(false);
      }
    };

    const handleCohortChange = async (
      index: number,
      value: any,
      type:
        | 'category'
        | 'property'
        | 'condition'
        | 'multipleProperties'
        | 'subCategory',
    ) => {
      let hasMultipleProperties = false;
      const updatedCohortDetails = cohortDetailsList.map((cohort, i) => {
        if (i === index) {
          cohort[type] = value;
        }

        if (i === index && type === 'category') {
          const dropDownIndex = categoryDropDownOptions.indexOf(value);

          cohort.dropdownSelectionTypeIndex = dropDownIndex;

          cohort.multipleProperties = [];
          cohort.property = '';
        }

        if (i === index && type === 'property') {
          cohort.property = value;
          setPropertiesSearchValue(value);
        }

        if (type === 'multipleProperties') {
          hasMultipleProperties = Array.isArray(value) && value.length > 0;
        }
        return { ...cohort };
      });

      const isPropertyValid =
        updatedCohortDetails[index]?.property !== '' &&
        updatedCohortDetails[index]?.property !== null;

      if (
        updatedCohortDetails[index]?.category !== '' &&
        updatedCohortDetails[index]?.condition !== '' &&
        (isPropertyValid || hasMultipleProperties)
      ) {
        const results = await getTotalMembers(updatedCohortDetails);

        const updatedResult = results === null ? '' : String(results);
        const percentage =
          results === null
            ? ''
            : String(
                roundNumber(
                  (results / parseInt(totalResults?.replaceAll(',', ''))) * 100,
                  2,
                ),
              );

        updatedCohortDetails[
          updatedCohortDetails.length - 1
        ].results = updatedResult;

        updatedCohortDetails[
          updatedCohortDetails.length - 1
        ].percentage = percentage;
      }

      cohortDetailsStore.setCohortDetailsList([...updatedCohortDetails]);
    };

    useEffect(() => {
      addToggleObject();
    }, [cohortDetailsList.length]);

    return (
      <>
        {cohortDetailsList.map((cohort, index) => {
          return (
            <Grid container className={classes.root} key={index}>
              <Grid container className={classes.cohortItem}>
                <Grid className={classes.inputFieldsGrid}>
                  <Grid>
                    <ReportCreateNewLabelField
                      label={constants.CATEGORY}
                      width="100%"
                      component={
                        <Dropdown
                          label={constants.SELECT}
                          dropDownOptions={categoryDropDownOptions ?? []}
                          dropDownValues={categoryDropDownOptions ?? []}
                          value={cohort.category}
                          setValue={null}
                          handleChange={(e) => {
                            handleCohortChange(
                              index,
                              e.target.value,
                              'category',
                            );
                            handlePageNumber(index, 0, 'propertiesPageNumber');
                            getPropertyValues(
                              cohort?.category,
                              '',
                              0,
                              false,
                              index,
                              cohort?.dropdownSelectionTypeIndex,
                            );
                          }}
                          selectStyles={{
                            ...commonDropDownProps.selectStyles,
                            width: '300px',
                          }}
                          labelTop="10px"
                          isTooltip={true}
                          tooltipValues={categoryDropDownOptions ?? []}
                        />
                      }
                    />
                  </Grid>
                  <Grid
                    container
                    sx={{
                      alignItems: 'flex-end',
                    }}
                  >
                    {/* {subCategoryDropDownOptions &&
                      subCategoryDropDownOptions[
                        cohort?.dropdownSelectionTypeIndex ?? -1
                      ]?.length > 0 && (
                        <Grid item style={{ marginRight: '20px' }}>
                          <ReportCreateNewLabelField
                            label="Sub Category"
                            component={
                              <Dropdown
                                label="Select"
                                dropDownOptions={
                                  subCategoryDropDownOptions[
                                    cohort?.dropdownSelectionTypeIndex ?? 0
                                  ] ?? []
                                }
                                dropDownValues={
                                  subCategoryDropDownOptions[
                                    cohort?.dropdownSelectionTypeIndex ?? 0
                                  ] ?? []
                                }
                                value={cohort?.subCategory ?? ''}
                                handleChange={(e) =>
                                  handleCohortChange(
                                    index,
                                    e.target.value,
                                    'subCategory',
                                  )
                                }
                                selectStyles={{
                                  ...commonDropDownProps.selectStyles,
                                  width: '192px',
                                }}
                                labelTop="10px"
                              />
                            }
                          />
                        </Grid>
                      )} */}
                    <Grid style={{ marginRight: '20px' }}>
                      <ReportCreateNewLabelField
                        label={constants.CONDITION}
                        component={
                          <Dropdown
                            label="Select"
                            dropDownOptions={
                              conditionDropDownOptions[
                                cohort?.dropdownSelectionTypeIndex
                              ] ?? []
                            }
                            dropDownValues={
                              conditionDropDownOptions[
                                cohort?.dropdownSelectionTypeIndex
                              ] ?? []
                            }
                            value={cohort.condition}
                            setValue={undefined}
                            handleChange={(e) =>
                              handleCohortChange(
                                index,
                                e.target.value,
                                'condition',
                              )
                            }
                            selectStyles={{
                              ...commonDropDownProps.selectStyles,
                              width: '220px',
                            }}
                            labelTop="10px"
                          />
                        }
                      />
                    </Grid>
                    <Grid style={{ marginRight: '20px' }}>
                      {Array.isArray(
                        propertyDropDownOptions?.[
                          cohort?.dropdownSelectionTypeIndex ?? -1
                        ],
                      ) &&
                      propertyDropDownOptions[
                        cohort.dropdownSelectionTypeIndex
                      ]?.[0] === 'numerical value' ? (
                        <ReportCreateNewLabelField
                          label={constants.PROPERTY}
                          component={
                            <TextField
                              value={cohort.property}
                              placeholder={constants.TEXT_FIELD_PLACEHOLDER}
                              height="36px"
                              width="301px"
                              inputPropsStyle={{
                                paddingLeft: '16px',
                              }}
                              onChange={(e: any) =>
                                handleCohortChange(
                                  index,
                                  e.target.value,
                                  'property',
                                )
                              }
                            />
                          }
                        />
                      ) : cohortSelectionsValues[
                          cohort?.dropdownSelectionTypeIndex
                        ] === 'single' ? (
                        <ReportCreateNewLabelField
                          label={constants.PROPERTY}
                          component={
                            <Autocomplete
                              style={{ width: '226px' }}
                              id="combo-box-demo"
                              options={
                                propertyDropDownOptions[
                                  cohort?.dropdownSelectionTypeIndex
                                ] ?? []
                              }
                              getOptionLabel={(option) =>
                                option.toString() ?? ''
                              }
                              noOptionsText="No Field found"
                              value={cohort.property}
                              loading={!!loadingPropertiesByIndex[index]}
                              loadingText="Loading Properties..."
                              onChange={(event, value) => {
                                handleCohortChange(index, value, 'property');
                                getPropertyValues(
                                  cohort?.category,
                                  value ?? '',
                                  0,
                                  true,
                                  index,
                                  cohort?.dropdownSelectionTypeIndex,
                                );
                              }}
                              classes={{
                                root: classes.autoCompleteDropdown,
                                input: classes.autoCompleteInput,
                                inputRoot: classes.autoCompleteInput,
                                paper: classes.paper,
                                tag: classes.tag,
                              }}
                              slotProps={{
                                listbox: {
                                  onScroll: (event: React.SyntheticEvent) => {
                                    const listboxNode = event.currentTarget;
                                    if (
                                      listboxNode.scrollTop +
                                        listboxNode.clientHeight ===
                                      listboxNode.scrollHeight
                                    ) {
                                      handleScrollEvent(
                                        cohort?.category,
                                        index,
                                        cohort?.dropdownSelectionTypeIndex,
                                        cohort?.propertiesPageNumber,
                                        cohort?.totalPagesForProperties,
                                      );
                                    }
                                  },
                                  style: {
                                    padding: '0px',
                                    boxSizing: 'border-box',
                                    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
                                    backgroundColor:
                                      patientAccessTheme.palette.status.white,
                                    margin: '0px',
                                    maxHeight: '280px',
                                  },
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  placeholder={'Select'}
                                  onChange={(event: any) =>
                                    handleTextFieldForProperties(
                                      event,
                                      cohort?.category,
                                      index,
                                      cohort?.dropdownSelectionTypeIndex,
                                    )
                                  }
                                />
                              )}
                              popupIcon={
                                loadingPropertiesByIndex[index] ? (
                                  <CircularProgress color="inherit" size={25} />
                                ) : (
                                  <ArrowDropDownIcon />
                                )
                              }
                            />
                          }
                        />
                      ) : (
                        <ReportCreateNewLabelField
                          label={constants.PROPERTY}
                          component={
                            <AutocompleteWithCheckBoxes
                              width="226px"
                              options={
                                propertyDropDownOptions?.[
                                  cohort?.dropdownSelectionTypeIndex ?? -1
                                ] || []
                              }
                              getOptionLabel={(option) =>
                                option.toString() ?? ''
                              }
                              handleChange={(e, value) =>
                                handleCohortChange(
                                  index,
                                  value,
                                  'multipleProperties',
                                )
                              }
                              defaultValue={cohort?.multipleProperties ?? []}
                              placeholder={
                                cohort?.multipleProperties?.length === 0
                                  ? 'Select'
                                  : ''
                              }
                              onScrollEvent={(event: React.SyntheticEvent) => {
                                const listboxNode = event.currentTarget;
                                if (
                                  listboxNode.scrollTop +
                                    listboxNode.clientHeight ===
                                  listboxNode.scrollHeight
                                ) {
                                  handleScrollEvent(
                                    cohort?.category,
                                    index,
                                    cohort?.dropdownSelectionTypeIndex,
                                    cohort?.propertiesPageNumber,
                                    cohort?.totalPagesForProperties,
                                  );
                                }
                              }}
                              popupIcon={
                                loadingPropertiesByIndex[index] ? (
                                  <CircularProgress color="inherit" size={25} />
                                ) : (
                                  <ArrowDropDownIcon />
                                )
                              }
                            />
                          }
                        />
                      )}
                    </Grid>
                    <Grid>
                      <SvgRefresh
                        height={'24px'}
                        width={'24px'}
                        style={{ marginBottom: '16px' }}
                        cursor={'pointer'}
                        onClick={() => {
                          handleDeleteCohort(index, true);
                        }}
                      />
                      {cohortDetailsList?.length > 1 ? (
                        <SvgDelete
                          height={'24px'}
                          width={'24px'}
                          style={{ marginBottom: '16px', marginLeft: '8px' }}
                          cursor={'pointer'}
                          onClick={() => {
                            handleToggleList(index);
                            handleDeleteCohort(index, false);
                          }}
                        />
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
                {loadingCohort ? (
                  <CircularLoader />
                ) : (
                  cohort?.results && (
                    <Grid className={classes.lineAndResultsGrid}>
                      <div
                        style={{
                          width: '3px',
                          background: '#E3EAFF',
                          height: index > 0 ? '210px' : '56px',
                          marginTop: index > 0 ? '-150px' : '0px',
                        }}
                      />
                      <Grid className={classes.resultsGrid}>
                        <Typography
                          fontSize="14px"
                          fontType="semiBold"
                          lineHeight="24px"
                          textColor={
                            patientAccessTheme.palette.text.highemphasis
                          }
                        >
                          {cohort?.results}
                          {'(' + cohort?.percentage + '%)'}
                        </Typography>
                      </Grid>
                    </Grid>
                  )
                )}
              </Grid>
              <Grid style={{ margin: '16px 0px' }}>
                {cohortDetailsList?.length > 1 &&
                  index !== cohortDetailsList?.length - 1 && (
                    <Grid>
                      <ToggleGroup
                        leftValue={constants.AND}
                        rightValue={constants.OR}
                        leftIcon={undefined}
                        rightIcon={undefined}
                        setSelectedToggle={setSelectedToggle}
                        showBothLabel={true}
                        toggleLeftSideStyles={toggleStyles}
                        toggleRightSideStyles={toggleStyles}
                        index={index}
                        handleIndexChange={handleToggleChange}
                      />
                    </Grid>
                  )}
              </Grid>
            </Grid>
          );
        })}
      </>
    );
  },
);

export default ReportsCohortItem;
